// Studio's binding of the engine's shared library loader: it supplies the base
// URL, the engine does the fetching and registration (see
// engine/content/packs/library/libraryLoader.ts). Kept as a module so callers
// keep importing `ensureLibraryLoaded()` with no argument.
import { ensureLibraryLoaded as ensureLibraryLoadedFrom } from '../../engine';

/**
 * The library base URL. Production builds point at the uploads CDN's /library
 * path via VITE_LIBRARY_BASE; dev defaults to the same-origin /library route
 * the Vite middleware serves from sstk-studio-infra's
 * scripts/workspace/asset-library/dist (see vite.config.ts).
 */
export const LIBRARY_BASE: string = import.meta.env.VITE_LIBRARY_BASE || '/library';

export function ensureLibraryLoaded(): Promise<void> {
  return ensureLibraryLoadedFrom(LIBRARY_BASE);
}
